import { Pipe, PipeTransform } from '@angular/core';

/**
 * Defense-in-depth pipe that marks user-controlled strings for safe display.
 * Use this on any user-provided data (printer name, printer location,
 * print queue name, print-job name, etc.) to explicitly signal that the
 * value is user-controlled and must be treated as plain text.
 *
 * Angular's {{ }} interpolation already HTML-escapes output, so this pipe
 * simply ensures the value is converted to a string. This prevents XSS-like
 * characters (e.g. <script>, <img onerror=...>) from being executed while
 * still displaying them as visible plain text to the user.
 *
 * Usage: {{ printer.name | sanitizeText }}
 */
@Pipe({
    name: 'sanitizeText',
    standalone: false
})
export class SanitizeTextPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (value == null) {
            return '';
        }
        return String(value);
    }
}
